module.exports = __webpack_public_path__ + "img/resource-no.86c3ee65.png";